import { useEffect, useRef, useState } from 'react';
import { StoreApi } from 'zustand';

export function createUseStore<S extends StoreApi<any>>(store: S) {
  type State = ReturnType<S['getState']>;
  return function useStore<Selected = State>(
    selector?: (state: State) => Selected,
    equalityFn?: (a: Selected, b: Selected) => boolean,
  ): Selected {
    const unsubscribe = useRef<() => void>(undefined);
    const [state, setState] = useState(selector?.(store.getState()) ?? store.getState());

    useEffect(() => {
      unsubscribe.current?.();
      unsubscribe.current = store.subscribe(setState, selector, equalityFn);
      return () => {
        unsubscribe.current?.();
        unsubscribe.current = undefined;
      };
    }, [store, selector, equalityFn]);

    return state;
  };
}
